import api from "../index";

export const GetAllEducationMaterialsApi = () =>
  api.get("KnowledgeHub/getall-education-materials");

export const AddUpdateEducationMaterialApi = (data) =>
  api.post("KnowledgeHub/add-update-education-material", data);

export const DeleteEducationMaterialApi = (materialId) =>
  api.delete(`KnowledgeHub/delete-education-material/${materialId}`);

export const GetEducationSectionsApi = (materialId) =>
  api.get(`KnowledgeHub/getall-education-sections/${materialId}`);

export const AddUpdateEducationSectionApi = (data) =>
  api.post("KnowledgeHub/add-update-education-section", data);

export const DeleteEducationSectionApi = (sectionId) =>
  api.delete(`KnowledgeHub/delete-education-section/${sectionId}`);

export const GetEducationUnitsApi = (sectionId) =>
  api.get(`KnowledgeHub/getall-education-units/${sectionId}`);

export const AddUpdateEducationUnitApi = (formData, config) =>
  api.post("KnowledgeHub/add-update-education-unit", formData, config);

export const DeleteEducationUnitApi = (unitId) =>
  api.delete(`KnowledgeHub/delete-education-unit/${unitId}`);
